import { DialogContent, Stack, Typography } from "@mui/material";
import React from "react";
import convertCurrency from "src/helper/convertCurrency";
import { formatCurrency } from "src/helper/convertNum";
import useInventoryNoteDetail from "src/hooks/inventory/useInventoryNoteDetail";
const STATUS = {
  Paid: "Đã thanh toán công nợ",
  Unpaid: "Chưa thanh toán công nợ",
};
const EXPORT_TYPE = {
  OrderReturn: "Xuất bỏ hàng hoàn",
  Manual: "Xuất bỏ thủ công",
};

export default function DebtDetailDialog({ item }) {
  const { data: detail } = useInventoryNoteDetail(item?._id);

  return (
    <DialogContent>
      <Stack gap={1.5}>
        <Typography>
          <strong>Xuất bỏ bởi:</strong> {detail?.data?.exportBy?.fullName ?? "-"}
        </Typography>
        <Typography>
          <strong>Tình trạng:</strong> {STATUS[detail?.data?.status] ?? "-"}
        </Typography>
        <Typography>
          <strong>Lý do:</strong> {detail?.data?.reason ?? "-"}
        </Typography>
        <Typography>
          <strong>Hình thức xuất bỏ:</strong> {EXPORT_TYPE[detail?.data?.exportType] ?? "-"}
        </Typography>
        <Typography>
          <strong>Giá trị:</strong> {formatCurrency(detail?.data?.total) ?? "-"}
          <br />
          <Typography component="span">({convertCurrency(detail?.data?.total)} đồng)</Typography>
        </Typography>
      </Stack>
    </DialogContent>
  );
}
